
import GwIcon from '~/patterns/atoms/icon/icon.vue';

export default {
    components: {
        GwIcon
    },
    props: {
        title: {
            type: String,
            default: null
        },
        status: {
            type: String,
            default: null
        },
        step: {
            type: Number,
            default: null
        },
        activeStep: {
            type: Number,
            default: null
        },
        subsections: {
            type: Number,
            default: 0
        }
    },
    computed: {
        active() {
            return this.activeStep === this.step;
        },

        completed() {
            return this.activeStep > this.step;
        },

        statusClass() {
            if (this.active) {
                return 'gw-form-section--active';
            } else if (this.completed) {
                return 'gw-form-section--completed';
            } else {
                return 'gw-form-section--unavailable';
            }
        }
    },
    methods: {
        handleEdit(step) {
            this.$emit('edit', step);
        }
    }
};
